define("shared/components/shared/social/refresh-profile/index", ["exports", "@ember/component", "@ember/debug", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "later/utils/constants", "shared/utils/is-async-relation", "@ember/template-factory"], function (_exports, _component, _debug, _object, _service, _component2, _tracking, _constants, _isAsyncRelation, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/debug",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"later/utils/constants",0,"shared/utils/is-async-relation",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#unless this.isLoading}}
    {{! Note: offload refresh handling to respective profile type-variants of buttons }}
    {{#if @socialProfile.isFacebook}}
      <Shared::Social::RefreshProfile::Facebook
        @buttonClass={{@buttonClass}}
        @buttonVariant={{@buttonVariant}}
        @isLocked={{@isLocked}}
        @onProfileRefresh={{this.onProfileRefresh}}
        @onProfileRefreshStart={{this.onProfileRefreshStart}}
        @severity={{this.severity}}
        @socialProfile={{@socialProfile}}
      />
    {{else if @socialProfile.isLinkedin}}
      <Shared::Social::RefreshProfile::Linkedin
        @buttonClass={{@buttonClass}}
        @buttonVariant={{@buttonVariant}}
        @isLocked={{@isLocked}}
        @onProfileRefresh={{this.onProfileRefresh}}
        @onProfileRefreshStart={{this.onProfileRefreshStart}}
        @severity={{this.severity}}
        @socialProfile={{@socialProfile}}
      />
    {{else if @socialProfile.isPinterest}}
      <Shared::Social::RefreshProfile::Pinterest
        @buttonClass={{@buttonClass}}
        @buttonVariant={{@buttonVariant}}
        @isLocked={{@isLocked}}
        @onProfileRefresh={{this.onProfileRefresh}}
        @onProfileRefreshStart={{this.onProfileRefreshStart}}
        @severity={{this.severity}}
        @socialProfile={{@socialProfile}}
      />
    {{else if (and @socialProfile.isTwitter (not this.rolloutTwitterSunset))}}
      <Shared::Social::RefreshProfile::Twitter
        @buttonClass={{@buttonClass}}
        @buttonVariant={{@buttonVariant}}
        @isLocked={{@isLocked}}
        @onProfileRefresh={{this.onProfileRefresh}}
        @onProfileRefreshStart={{this.onProfileRefreshStart}}
        @severity={{this.severity}}
        @socialProfile={{@socialProfile}}
      />
    {{else if @socialProfile.isThreads}}
      <Shared::Social::RefreshProfile::Threads
        @buttonClass={{@buttonClass}}
        @buttonVariant={{@buttonVariant}}
        @isLocked={{@isLocked}}
        @onProfileRefresh={{this.onProfileRefresh}}
        @onProfileRefreshStart={{this.onProfileRefreshStart}}
        @severity={{this.severity}}
        @socialProfile={{@socialProfile}}
      />
    {{else if @socialProfile.isSnapchat}}
      <Shared::Social::RefreshProfile::Snapchat
        @buttonClass={{@buttonClass}}
        @buttonVariant={{@buttonVariant}}
        @isLocked={{@isLocked}}
        @onProfileRefresh={{this.onProfileRefresh}}
        @onProfileRefreshStart={{this.onProfileRefreshStart}}
        @severity={{this.severity}}
        @socialProfile={{@socialProfile}}
      />
    {{/if}}
  {{/unless}}
  */
  {
    "id": "BEZ8qo6B",
    "block": "[[[41,[51,[30,0,[\"isLoading\"]]],[[[41,[30,1,[\"isFacebook\"]],[[[1,\"    \"],[8,[39,2],null,[[\"@buttonClass\",\"@buttonVariant\",\"@isLocked\",\"@onProfileRefresh\",\"@onProfileRefreshStart\",\"@severity\",\"@socialProfile\"],[[30,2],[30,3],[30,4],[30,0,[\"onProfileRefresh\"]],[30,0,[\"onProfileRefreshStart\"]],[30,0,[\"severity\"]],[30,1]]],null],[1,\"\\n\"]],[]],[[[41,[30,1,[\"isLinkedin\"]],[[[1,\"    \"],[8,[39,3],null,[[\"@buttonClass\",\"@buttonVariant\",\"@isLocked\",\"@onProfileRefresh\",\"@onProfileRefreshStart\",\"@severity\",\"@socialProfile\"],[[30,2],[30,3],[30,4],[30,0,[\"onProfileRefresh\"]],[30,0,[\"onProfileRefreshStart\"]],[30,0,[\"severity\"]],[30,1]]],null],[1,\"\\n\"]],[]],[[[41,[30,1,[\"isPinterest\"]],[[[1,\"    \"],[8,[39,4],null,[[\"@buttonClass\",\"@buttonVariant\",\"@isLocked\",\"@onProfileRefresh\",\"@onProfileRefreshStart\",\"@severity\",\"@socialProfile\"],[[30,2],[30,3],[30,4],[30,0,[\"onProfileRefresh\"]],[30,0,[\"onProfileRefreshStart\"]],[30,0,[\"severity\"]],[30,1]]],null],[1,\"\\n\"]],[]],[[[41,[28,[37,5],[[30,1,[\"isTwitter\"]],[28,[37,6],[[30,0,[\"rolloutTwitterSunset\"]]],null]],null],[[[1,\"    \"],[8,[39,7],null,[[\"@buttonClass\",\"@buttonVariant\",\"@isLocked\",\"@onProfileRefresh\",\"@onProfileRefreshStart\",\"@severity\",\"@socialProfile\"],[[30,2],[30,3],[30,4],[30,0,[\"onProfileRefresh\"]],[30,0,[\"onProfileRefreshStart\"]],[30,0,[\"severity\"]],[30,1]]],null],[1,\"\\n\"]],[]],[[[41,[30,1,[\"isThreads\"]],[[[1,\"    \"],[8,[39,8],null,[[\"@buttonClass\",\"@buttonVariant\",\"@isLocked\",\"@onProfileRefresh\",\"@onProfileRefreshStart\",\"@severity\",\"@socialProfile\"],[[30,2],[30,3],[30,4],[30,0,[\"onProfileRefresh\"]],[30,0,[\"onProfileRefreshStart\"]],[30,0,[\"severity\"]],[30,1]]],null],[1,\"\\n\"]],[]],[[[41,[30,1,[\"isSnapchat\"]],[[[1,\"    \"],[8,[39,9],null,[[\"@buttonClass\",\"@buttonVariant\",\"@isLocked\",\"@onProfileRefresh\",\"@onProfileRefreshStart\",\"@severity\",\"@socialProfile\"],[[30,2],[30,3],[30,4],[30,0,[\"onProfileRefresh\"]],[30,0,[\"onProfileRefreshStart\"]],[30,0,[\"severity\"]],[30,1]]],null],[1,\"\\n  \"]],[]],null]],[]]]],[]]]],[]]]],[]]]],[]]]],[]],null]],[\"@socialProfile\",\"@buttonClass\",\"@buttonVariant\",\"@isLocked\"],false,[\"unless\",\"if\",\"shared/social/refresh-profile/facebook\",\"shared/social/refresh-profile/linkedin\",\"shared/social/refresh-profile/pinterest\",\"and\",\"not\",\"shared/social/refresh-profile/twitter\",\"shared/social/refresh-profile/threads\",\"shared/social/refresh-profile/snapchat\"]]",
    "moduleName": "shared/components/shared/social/refresh-profile/index.hbs",
    "isStrictMode": false
  });
  /**
   * Note: we only support a subset of profiles for this component.
   */
  const SUPPORTED_PROFILE_TYPES = [_constants.SocialProfileType.Facebook, _constants.SocialProfileType.Linkedin, _constants.SocialProfileType.Pinterest, _constants.SocialProfileType.Twitter, _constants.SocialProfileType.Threads, _constants.SocialProfileType.Snapchat];

  /**
   * Ensure the provided social profile is supported in this component.
   * @param socialProfile
   * @throws When social profile type is `undefined` or unsupported.
   */
  function ensureSupportedProfile(socialProfile) {
    if (!socialProfile.profileType) {
      (false && !(false) && (0, _debug.assert)('No profile type found on social profile'));
    }
    const isSupported = SUPPORTED_PROFILE_TYPES.includes(socialProfile.profileType);
    if (!isSupported) {
      (false && !(false) && (0, _debug.assert)('Unsupported profile type provided to `RefreshProfile` component'));
    }
  }
  let RefreshProfileComponent = _exports.default = (_class = class RefreshProfileComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "isLoading", _descriptor2, this);
      if (!this.args.socialProfile) {
        (false && !(false) && (0, _debug.assert)('RefreshProfileComponent: missing required argument `socialProfile`'));
      }
      if ((0, _isAsyncRelation.isAsyncRelation)(this.args.socialProfile)) {
        this.args.socialProfile.then(socialProfile => {
          ensureSupportedProfile(socialProfile);
          this.isLoading = false;
        });
      } else {
        ensureSupportedProfile(this.args.socialProfile);
        this.isLoading = false;
      }
    }
    get rolloutTwitterSunset() {
      return this.auth.currentAccount.rolloutTwitterSunset;
    }
    async onProfileRefreshStart(socialProfile) {
      this.args.onProfileRefreshStart?.(socialProfile);
    }
    async onProfileRefresh(socialProfile, result) {
      if (!result.error) {
        await socialProfile.refreshProfile();
        await socialProfile.reload();
        if (socialProfile.isPinterest) {
          // Note: to validate pinterest refresh was successful we attempt to
          // fetch boards, and if it fails with code "3", we know something
          // went wrong.
          const codeRed = 3;
          const response = await socialProfile.pinterestBoards({});
          if (response.code !== codeRed) {
            // Note: this is to disable the socialProfile's `needsRefresh` state
            // for Pinterest accounts. We don't store (or use) an actual token on the client,
            // but we still use it to determine it's need for refreshing..?
            socialProfile.set('token', 'ARBITRARY_FAKE_TOKEN');
          }
        }
      }
      this.args.onProfileRefresh?.(socialProfile, result);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isLoading", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return true;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "onProfileRefreshStart", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onProfileRefreshStart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onProfileRefresh", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onProfileRefresh"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, RefreshProfileComponent);
});